import React from 'react';
import './category-cards.css'

const Categorycards = (props) => {
    
    return ( 
        <article className='card-sec4'>
            <figure className='img-container-sec4'>
                    <img src={props.pic} alt={props.alt}></img>
            </figure>
            <h2 className='category-title'>{props.title}</h2>

        </article>
     );
}
 
export default Categorycards;